import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import Select from "react-select";
import PinService from "../../../../services/PinService";

const PinMarketPlace = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const pinService = new PinService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const search = useSelector((state) => state.auth.search);
	const [params, setParams] = useState({});
	const [paramsData, setParamsData] = useState({
		type: "",
		date: "",
		time: "",
	});

	useEffect(() => {
		// if (!!paramsData?.date || !!paramsData?.date || !!paramsData?.time) {
		let paramsUpdate = {};
		if (!!paramsData?.match_type)
			paramsUpdate["type"] = paramsData?.type?.value;
		if (!!paramsData?.date) paramsUpdate["date"] = paramsData?.date;
		if (!!paramsData?.time) paramsUpdate["time"] = paramsData?.time;
		setParams(paramsUpdate);
		setShouldUpdate((prev) => !prev);
		// }
	}, [paramsData]);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].pin_market_place}
						</span>
					</div>
				</div>
			</div>
			<div class="accordion " id="accordionExample">
				<div class="accordion-item border-shadow p-0">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button fw-bold"
							type="button"
							style={{
								fontSize: "18px",
								background: "none",
								boxShadow: "none",
								color: "#000",
							}}
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne">
							{Translate[lang].filter}
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample">
						<div class="accordion-body px-0">
							<div className="row w-100 m-auto">
								<div className="col-md-3 col-6">
									<label className="d-block fw-bold">
										{Translate[lang].date}
									</label>
									<input
										type="date"
										name={"date"}
										value={paramsData?.date}
										placeholder={Translate[lang].date}
										style={{
											height: "43px",
											padding: "0 10px",
											borderRadius: "10px",
											border: "1px solid hsl(0, 0%, 80%)",
											width: "100%",
										}}
										onChange={(e) =>
											setParamsData((prev) => ({
												...prev,
												date: e.target?.value,
											}))
										}
									/>
								</div>
								<div className="col-md-3 col-6">
									<label className="d-block fw-bold">
										{Translate[lang].time}
									</label>
									<input
										type="time"
										name={"time"}
										value={paramsData?.time}
										placeholder={Translate[lang].time}
										style={{
											height: "43px",
											padding: "0 10px",
											borderRadius: "10px",
											border: "1px solid hsl(0, 0%, 80%)",
											width: "100%",
										}}
										onChange={(e) =>
											setParamsData((prev) => ({
												...prev,
												time: e.target?.value,
											}))
										}
									/>
								</div>
								<div className="col-md-3 col-6">
									<label className="fw-bold">{Translate[lang].type}</label>
									<Select
										options={[]}
										value={paramsData?.type}
										onChange={(e) => {
											setParamsData((prev) => ({
												...prev,
												type: e,
											}));
										}}
									/>
								</div>
								<div className={"col-md-2 col-6"}>
									<div className="d-flex h-100 gap-8 align-items-center">
										{(!!paramsData?.type ||
											!!paramsData?.time ||
											!!paramsData?.date) && (
											<Button
												variant="outline-danger"
												className="w-100"
												onClick={() => {
													setParamsData((prev) => ({
														...prev,
														date: "",
														time: "",
														type: "",
													}));
													setShouldUpdate((prev) => !prev);
												}}>
												{Translate[lang].clear_filter}
											</Button>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="mt-4">
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.type}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.date}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.time}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.length > 0 &&
									data?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setData}
						service={pinService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						param={params}
					/>
				</div>
			</div>
		</div>
	);
};
export default PinMarketPlace;
